import { useState, useEffect, useCallback } from 'react';
import { getLearningProgress, updateLearningProgress } from '../../../config/api';
import { LearningProgress } from '../types';

export function useLearningProgress(userId: string) {
  const [progress, setProgress] = useState<LearningProgress | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        setIsLoading(true);
        const data = await getLearningProgress(userId);
        setProgress(data.progress);
      } catch (err) {
        console.error('Error fetching learning progress:', err);
        setError('Failed to load learning progress');
      } finally {
        setIsLoading(false);
      }
    };

    if (userId) {
      fetchProgress();
    } else {
      setProgress(null);
      setIsLoading(false);
    }
  }, [userId]);

  const saveProgress = useCallback(
    async (data: Partial<LearningProgress>) => {
      try {
        const result = await updateLearningProgress(userId, data);
        setProgress(result.progress);
        return result.progress;
      } catch (err) {
        console.error('Error saving learning progress:', err);
        throw err;
      }
    },
    [userId]
  );

  return { progress, isLoading, error, saveProgress };
}
